import { RemoveOutlinedIcon } from '@shared/components';
import { useMemo } from 'react';

import { BULK_PERMISSION_NAME } from '../../constants';
import type { AppPermissionDetails, ActionPermissionType } from '../../types';
import { extractToCategoryAndName } from '../../utils';

import BulkPermissionCheckbox from './bulk-permission-checkbox';
import SinglePermissionCheckbox from './single-permission-checkbox';

interface PermissionCheckboxProps {
  row: AppPermissionDetails;
  action: ActionPermissionType;
  bulkActionCheckbox?: boolean;
  permissions?: AppPermissionDetails[];
}

export default function PermissionCheckbox(props: Readonly<PermissionCheckboxProps>) {
  const { row, action, bulkActionCheckbox: isBulkActionCheckbox = false, permissions } = props;
  const { id } = row;
  const { category, name } = isBulkActionCheckbox
    ? { category: id, name: BULK_PERMISSION_NAME }
    : extractToCategoryAndName(id);

  const hasNoPermission = useMemo(() => {
    return permissions?.every((permission) => {
      if (permission.type === 'feature' && permission.header === category) {
        return permission[action] === undefined;
      }
      return true;
    });
  }, [permissions, category, action]);

  if (!hasNoPermission) {
    if (isBulkActionCheckbox && permissions !== undefined) {
      return (
        <BulkPermissionCheckbox
          permissions={permissions}
          category={category}
          name={name}
          action={action}
        />
      );
    }
    if (row[action] !== undefined) {
      return <SinglePermissionCheckbox category={category} name={name} action={action} />;
    }
  }

  return (
    <RemoveOutlinedIcon
      sx={(theme) => ({
        fontSize: '24px',
        color: theme.palette.grey[400],
      })}
    />
  );
}
